import styled from '@emotion/styled';
import { Layout } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Iframe from 'react-iframe';
import { MISC } from '../../../constants/define/translation';
import { appStyles } from '../../../styles';
import { ContentPageHeader } from '../../molecules/page-header/ContentPageHeader';

const { Content } = Layout;

export const ServerHealth = () => {
  const { t } = useTranslation(MISC);
  return (
    <>
      <Container>
        <Content style={{ height: '100vh' }}>
          <ContentPageHeader title={t('title.serverHealth')} extra={[]} />
          <Iframe
            url={process.env.REACT_APP_STATUS_PAGE || ''}
            width="100%"
            height="70%"
            id="myId"
            className="status-page"
            display="block"
            position="relative"
            frameBorder={0}
          />
        </Content>
      </Container>
    </>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}

  & .ant-pagination {
    float: right;
    padding: 15px 0 0 0;
  }

  .btn-generate-access-code,
  .btn-export-access-code {
    width: 140px;
  }
`;
